// src/SbscContext.js -> Students By Subject Code
import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../config';

const SbscContext = createContext();

export function SBSCProvider({ children }) {
  const [sbscData, setSbscData] = useState([]);
  const [loading, setLoading] = useState(false);

  
  const fetchsbscData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${config.apiBaseUrl}/sbscode/sbscode.php`);
      const data = await response.json();
      setSbscData(data);
    } catch (error) {
      console.error('Error fetching fee data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchsbscData();
  }, []);

  const reloadSbscData = () => {
    fetchsbscData();
  };

 
  return (
    <SbscContext.Provider value={{ sbscData, loading, reloadSbscData }}>
      {children}
    </SbscContext.Provider>
  );
}

export function useSbscData() {
  const context = useContext(SbscContext);
  if (context === undefined) {
    throw new Error('useSbscData must be used within a SBSCProvider');
  }
  return context;
}
